angular.module("UI8.services").service("FavoriteService", [
  "$http",
  function ($http) {
    /**
     * Paginated card-shaped favorites, newest-favorite first.
     * No {cache: true} — the list must reflect toggles between visits.
     */
    this.list = function (page, category) {
      var url = "/account/favorites?json=1&full=1&page=" + (page || 1);
      if (category) url += "&category=" + encodeURIComponent(category);

      return $http
        .get(url)
        .then(function (res) {
          return res.data;
        })
        .catch(function () {
          return { products: [], total: 0, page: 1 };
        });
    };
  },
]);
